module.exports = __webpack_public_path__ + "static/media/okladka-katalog.faa31b76.webp";